import "./src/assets/css/global.css";
import { restoreConsent, trackPageView } from "./src/utils/consent";

// Re-apply a stored consent decision as early as the browser runtime allows,
// so an accepting visitor's trackers load without waiting for the banner.
export const onClientEntry = () => {
  restoreConsent();
};

// The Facebook pixel plugin used to fire a PageView per route change; it is
// loaded manually now, so the SPA navigations need tracking here. No-ops
// entirely when consent was never granted.
export const onRouteUpdate = () => {
  trackPageView();
};
